import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api/api.service';
import { ITrainingCenter, TrainingCenter } from '@precheckin/models/training-center/training-center.model';
import { lastValueFrom, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrainingCenterService {
  private readonly endpoint = `TrainingCenter`;

  constructor(private apiService: ApiService) { }

  public getById(id: string): Promise<ITrainingCenter> {
    return lastValueFrom(
      this.apiService
        .get<ITrainingCenter>(`${this.endpoint}/${id}`)
        .pipe(map((response) => new TrainingCenter(response)))
    );
  }

  public getByTrainingCenterId(
    trainingCenterId: string
  ): Observable<ITrainingCenter> {
    return this.apiService.get<ITrainingCenter>(
      `${this.endpoint}/${trainingCenterId}`
    );
  }
}
